import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { useMessageStore } from "@/stores/MessageStore";
const SUMUP_SCRIPT_SRC = 'https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SumUpPaymentView',
    setup(__props) {
        const messageStore = useMessageStore();
        const route = useRoute();
        const router = useRouter();
        const checkoutId = route.query.checkoutId;
        const loading = ref(true);
        let cardWidget = null;
        onMounted(async () => {
            const script = document.createElement('script');
            script.src = SUMUP_SCRIPT_SRC;
            script.onload = async () => {
                loading.value = false;
                await nextTick();
                mountWidget();
            };
            script.onerror = () => {
                loading.value = false;
                messageStore.addError('Deine Buchung wurde erfasst, aber das Zahlungsformular konnte nicht geladen werden. Bitte kontaktiere uns.');
            };
            document.head.appendChild(script);
        });
        onUnmounted(() => {
            cardWidget?.unmount();
            cardWidget = null;
        });
        function mountWidget() {
            console.log(checkoutId);
            const container = document.getElementById('sumup-card');
            if (container)
                container.innerHTML = '';
            // @ts-ignore — SumUpCard is loaded via CDN script
            cardWidget = SumUpCard.mount({
                id: 'sumup-card',
                checkoutId: checkoutId,
                onResponse: handleResponse,
            });
        }
        async function handleResponse(type) {
            switch (type) {
                case 'sent':
                case 'invalid':
                case 'auth-screen':
                    return;
                case 'success':
                    loading.value = true;
                    await pollUntilPaid();
                    break;
                default:
                    messageStore.addError('Deine Bestellung wurde erfasst, aber beim Verarbeiten der Zahlung ist ein Fehler aufgetreten. Bitte versuche es erneut, versuche eine andere Karte oder kontaktiere uns.');
                    break;
            }
        }
        async function pollUntilPaid(attempts = 0) {
            if (attempts > 10) {
                messageStore.addError('Die Verarbeitung der Zahlung dauert länger als üblich. Deine Bestellung wurde aufgenommen. Wir werden dich kontaktieren.');
                router.push({ name: 'orderReceived' });
                return;
            }
            try {
                const response = await axios.get('/sumup/checkout/status', { params: { checkoutId } });
                if (response.data?.status === 'PAID') {
                    router.push({ name: 'orderReceived' });
                }
                else if (response.data?.status === 'FAILED') {
                    messageStore.addError('Ihre Bestellung wurde erfasst, aber die Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut, versuchen sie eine andere Karte oder kontaktieren sie uns.');
                    loading.value = false;
                    await nextTick();
                    mountWidget();
                }
                else {
                    setTimeout(() => pollUntilPaid(attempts + 1), 1500);
                }
            }
            catch {
                setTimeout(() => pollUntilPaid(attempts + 1), 1500);
            }
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex flex-column align-center pa-4" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex text-h4 justify-center pa-0 pb-4" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createTextVNode("Zahlung")
                        ])),
                        _: 1
                    }),
                    (loading.value)
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            size: "64",
                            class: "mt-8"
                        }))
                        : (_openBlock(), _createBlock(_component_v_container, {
                            key: 1,
                            class: "v-col-12 pa-0"
                        }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createElementVNode("div", {
                                    id: "sumup-card",
                                    class: "w-100"
                                }, null, -1)
                            ])),
                            _: 1
                        }))
                ]),
                _: 1
            }));
        };
    }
});
